/* global EfxConsumerApiConstants EfxConsumerApiClient */

import _get from 'lodash/get';
import _has from 'lodash/has';
import {buildCreditScoreData} from '../helpers/buildCreditScoreData';
import {buildCreditReportData} from '../helpers/buildCreditReportData';
import {getJWT} from './jwt';
import utils from '../helpers/utils';
import {api} from '../helpers/api';

//Common
export const SET_PROVIDER_BUREAU_DATA = 'SET_PROVIDER_BUREAU_DATA';

//Equifax
export const CREDIT_SCORE = 'CREDIT_SCORE';
export const CREDIT_SCORE_STATUS = 'CREDIT_SCORE_STATUS';
export const CREDIT_SCORE_HISTORY = 'CREDIT_SCORE_HISTORY';
export const CREDIT_SCORE_HISTORY_STATUS = 'CREDIT_SCORE_HISTORY_STATUS';
export const CREDIT_REPORT = 'CREDIT_REPORT';
export const CREDIT_REPORT_STATUS = 'CREDIT_REPORT_STATUS';
export const CREDIT_REPORT_ABSTRACT = 'CREDIT_REPORT_ABSTRACT';
export const CREDIT_REPORT_ABSTRACT_STATUS = 'CREDIT_REPORT_ABSTRACT_STATUS';
export const EQUIFAX_STATUS = 'EQUIFAX_STATUS';
export const DOWNLOAD_REPORT_STATUS = 'DOWNLOAD_REPORT_STATUS';
export const CREDIT_FULFILLMENT_REQUEST = 'CREDIT_FULFILLMENT_REQUEST';
export const CREDIT_FULFILLMENT_SUCCESS = 'CREDIT_FULFILLMENT_SUCCESS';
export const CREDIT_FULFILLMENT_FAILURE = 'CREDIT_FULFILLMENT_FAILURE';
export const CREDIT_PULLINFO_REQUEST = 'CREDIT_PULLINFO_REQUEST';
export const CREDIT_PULLINFO_SUCCESS = 'CREDIT_PULLINFO_SUCCESS';
export const CREDIT_PULLINFO_FAILURE = 'CREDIT_PULLINFO_FAILURE';
export const CREDIT_ON_DEMAND = 'CREDIT_ON_DEMAND';
export const CLEAR_FULFILLMENT_INFO = 'CLEAR_FULFILLMENT_INFO';

//TransUnion
export const TU_REPORT_HISTORY_REQUEST = 'REPORT_HISTORY_REQUEST';
export const TU_REPORT_HISTORY_SUCCESS = 'REPORT_HISTORY_SUCCESS';
export const TU_REPORT_HISTORY_FAILURE = 'REPORT_HISTORY_FAILURE';
export const TU_REPORT_REQUEST = 'REPORT_REQUEST';
export const TU_REPORT_SUCCESS = 'REPORT_SUCCESS';
export const TU_REPORT_FAILURE = 'REPORT_FAILURE';

//Common
export function setProviderBureauData(bureau: string, creditMax: $TSFixMe) {
  return {
    type: SET_PROVIDER_BUREAU_DATA,
    bureau,
    creditMax,
  };
}

//Equifax
export function getCreditScore(clientLibraryInstance: $TSFixMe, localizedStringBundle: StringMap, langCode: $TSFixMe) {
  const startTime = Date.now();
  return (dispatch: $TSFixMe) => {
    dispatch({type: 'CREDIT_SCORE_STATUS', credit_score_status: 'loading'});
    return clientLibraryInstance.getCreditScoreLatest().then(
      (response: $TSFixMe) => {
        const creditScoreData = buildCreditScoreData(response, localizedStringBundle, langCode, 'EFX');
        dispatch({type: 'CREDIT_SCORE', credit_score: creditScoreData});
      },
      (error: $TSFixMe) => {
        utils.log(buildEfxLogInfo(error, startTime));
        dispatch({type: 'CREDIT_SCORE_STATUS', credit_score_status: 'error', status_text: error.statusText || ''});
        throw error;
      }
    );
  };
}

export function getCreditScoreHistory(clientLibraryInstance: $TSFixMe) {
  const startTime = Date.now();
  return (dispatch: $TSFixMe) => {
    dispatch({type: 'CREDIT_SCORE_HISTORY_STATUS', credit_score_history_status: 'loading'});
    return clientLibraryInstance.getCreditScoresHistory('US_EFX').then(
      (response: $TSFixMe) => {
        dispatch({type: 'CREDIT_SCORE_HISTORY', credit_score_history: response});
      },
      (error: $TSFixMe) => {
        utils.log(buildEfxLogInfo(error, startTime));
        dispatch({
          type: 'CREDIT_SCORE_HISTORY_STATUS',
          credit_score_history_status: 'error',
          credit_score_history_error: error,
        });
        throw error;
      }
    );
  };
}

export function getCreditReport(
  clientLibraryInstance: $TSFixMe,
  localizedStringBundle: StringMap,
  langCode: $TSFixMe,
  is3BUser: $TSFixMe,
  creditPullInfo: $TSFixMe
) {
  const startTime = Date.now();
  return (dispatch: $TSFixMe) => {
    dispatch({type: 'CREDIT_REPORT_STATUS', credit_report_status: 'loading'});
    return clientLibraryInstance.getCreditReportLatest().then(
      (response: $TSFixMe) => {
        const creditReportData = buildCreditReportData(response, localizedStringBundle, langCode, 'EFX');
        if (
          Array.isArray(response.providerViews) &&
          response.providerViews.length === 1 &&
          is3BUser &&
          creditPullInfo.isFulfilled3BReportAvailable
        ) {
          dispatch(
            getCreditReportByType(clientLibraryInstance, localizedStringBundle, langCode, 'US_3B', creditReportData)
          );
        } else {
          dispatch({type: 'CREDIT_REPORT', credit_report: creditReportData});
        }
      },
      (error: $TSFixMe) => {
        utils.log(buildEfxLogInfo(error, startTime));
        dispatch({type: 'CREDIT_REPORT_STATUS', credit_report_status: 'error', credit_report_error: error});
        throw error;
      }
    );
  };
}

export function getCreditReportByType(
  clientLibraryInstance: $TSFixMe,
  localizedStringBundle: StringMap,
  langCode: $TSFixMe,
  type: $TSFixMe,
  latestData: $TSFixMe
) {
  const startTime = Date.now();
  return (dispatch: $TSFixMe) => {
    dispatch({type: 'CREDIT_REPORT_STATUS', credit_report_status: 'loading'});
    return clientLibraryInstance.getCreditReportLatestByType(type).then(
      (response: $TSFixMe) => {
        const creditReportData = buildCreditReportData(response, localizedStringBundle, langCode, 'EFX');
        const latestProviders = _get(latestData, 'latest.providers', []);
        const providersToMerge = _get(creditReportData, 'latest.providers', []).filter(
          (bureau: $TSFixMe) => bureau.provider !== 'EFX'
        );
        if (_has(latestData, 'latest.providers')) {
          latestData.latest.providers = [...latestProviders, ...providersToMerge];
        } else {
          latestData = creditReportData;
        }
        dispatch({type: 'CREDIT_REPORT', credit_report: latestData});
      },
      (error: $TSFixMe) => {
        utils.log(buildEfxLogInfo(error, startTime));
        dispatch({type: 'CREDIT_REPORT_STATUS', credit_report_status: 'error', credit_report_error: error});
      }
    );
  };
}

export function downloadCreditReport(reportid: $TSFixMe) {
  return (dispatch: $TSFixMe, getState: $TSFixMe) => {
    dispatch({type: 'DOWNLOAD_REPORT_STATUS', download_report_status: 'loading'});

    const accountId = _get(getState().auth, 'user.primaryMember.accountId');

    // @ts-expect-error TS(2554) FIXME: Expected 1 arguments, but got 2.
    return dispatch(getJWT(null, accountId)).then(() => {
      const tokenObject = getState().jwt;
      const equifaxApiKey = _get(tokenObject, 'jwt.vendorInfo.equifaxApiKey');
      const equifaxEndPoint = _get(tokenObject, 'jwt.vendorInfo.equifaxEndPoint');
      const jwtToken = _get(tokenObject, 'jwt.jwtToken');

      if (!equifaxApiKey || !equifaxEndPoint || !jwtToken) {
        //TODO: We need error case specific for printing credit report
        return null;
      }
      // @ts-expect-error TS(2304) FIXME: Cannot find name 'EfxConsumerApiClient'.
      return EfxConsumerApiClient({
        apiKey: equifaxApiKey,
        server: equifaxEndPoint,
        clientAssertion: jwtToken,
      }).then(
        (clientLibraryInstance: $TSFixMe) => {
          dispatch({type: 'DOWNLOAD_REPORT_STATUS', download_report_status: 'success'});
          return clientLibraryInstance.getDownloadCreditReportPDFLink(reportid);
        },
        (error: $TSFixMe) => {
          dispatch({type: 'DOWNLOAD_REPORT_STATUS', download_report_status: 'error', download_report_error: error});
        }
      );
    });
  };
}

export function getCreditReportAbstract(clientLibraryInstance: $TSFixMe) {
  const startTime = Date.now();
  return (dispatch: $TSFixMe) => {
    dispatch({type: 'CREDIT_REPORT_ABSTRACT_STATUS', credit_report_abstract_status: 'loading'});
    return clientLibraryInstance.getCreditReportAbstract().then(
      (response: $TSFixMe) => {
        dispatch({type: 'CREDIT_REPORT_ABSTRACT', credit_report_abstract: response});
        dispatch({type: 'CREDIT_REPORT_ABSTRACT_STATUS', credit_report_abstract_status: 'success'});
      },
      (error: $TSFixMe) => {
        utils.log(buildEfxLogInfo(error, startTime));
        dispatch({
          type: 'CREDIT_REPORT_ABSTRACT_STATUS',
          credit_report_abstract_status: 'error',
          credit_report_abstract_status_error: error,
        });
      }
    );
  };
}
export function equifaxClient(
  tokenObject: $TSFixMe,
  localizedStringBundle: StringMap,
  langCode: $TSFixMe,
  is3BUser: $TSFixMe,
  creditPullInfo: $TSFixMe
) {
  const startTime = Date.now();
  return (dispatch: $TSFixMe) => {
    const venderInfoScope = _get(tokenObject, 'vendorInfo.scope');
    const equifaxApiKey = _get(tokenObject, 'vendorInfo.equifaxApiKey');
    const equifaxEndPoint = _get(tokenObject, 'vendorInfo.equifaxEndPoint');
    const jwtToken = _get(tokenObject, 'jwtToken');
    const scope =
      venderInfoScope === 'delivery'
        ? // @ts-expect-error TS(2304) FIXME: Cannot find name 'EfxConsumerApiConstants'.
          EfxConsumerApiConstants.ApiChannel.DELIVERY
        : // @ts-expect-error TS(2304) FIXME: Cannot find name 'EfxConsumerApiConstants'.
          EfxConsumerApiConstants.ApiChannel.PROXY_DELIVERY;

    if (!equifaxApiKey || !equifaxEndPoint || !jwtToken) {
      dispatch({type: 'EQUIFAX_STATUS', equifax_status: 'error'});
      return null;
    }

    // @ts-expect-error TS(2304) FIXME: Cannot find name 'EfxConsumerApiClient'.
    return EfxConsumerApiClient({
      scope,
      apiKey: equifaxApiKey,
      server: equifaxEndPoint,
      clientAssertion: jwtToken,
    }).then(
      (clientLibraryInstance: $TSFixMe) => {
        dispatch(getCreditScore(clientLibraryInstance, localizedStringBundle, langCode));
        dispatch(getCreditReportAbstract(clientLibraryInstance));
        dispatch(getCreditScoreHistory(clientLibraryInstance));
        dispatch(getCreditReport(clientLibraryInstance, localizedStringBundle, langCode, is3BUser, creditPullInfo));
      },
      (error: $TSFixMe) => {
        utils.log({
          feature: 'Credit',
          actionType: `EFX client call - ${equifaxEndPoint}`,
          message: error,
          statusCode: 401,
          // @ts-expect-error TS(2362) FIXME: The left-hand side of an arithmetic operation must... Remove this comment to see the full error message
          elapsedTime: new Date() - startTime,
          clientId: window.isDwm ? 'dwm' : 'dsp',
        });
        dispatch({type: 'EQUIFAX_STATUS', equifax_status: 'error', equifax_error: error});
      }
    );
  };
}

// Exported wrapper used solely by credit.test.js to mock equifaxClient when testing
// callEfx.
export const creditLib = {
  equifaxClient,
};

export const callEfx = (
  accountId: $TSFixMe,
  localizedStringBundle: StringMap,
  langCode: $TSFixMe,
  is3BUser: $TSFixMe,
  creditPullInfo: $TSFixMe
) => {
  return (dispatch: $TSFixMe) => {
    return dispatch(getJWT(accountId))
      .then((response: $TSFixMe) => {
        const jwtObj = _get(response, 'jwt');
        dispatch(creditLib.equifaxClient(jwtObj, localizedStringBundle, langCode, is3BUser, creditPullInfo));
      })
      .catch((error: $TSFixMe) => {
        dispatch({type: 'EQUIFAX_STATUS', equifax_status: 'error', rawError: error});
      });
  };
};

// Credit On Demand
export function setCreditOnDemand() {
  return {
    type: CREDIT_ON_DEMAND,
  };
}

function getCreditPullInfoRequest() {
  return {
    type: CREDIT_PULLINFO_REQUEST,
  };
}

function getCreditPullInfoFailure(error: $TSFixMe) {
  return {
    type: CREDIT_PULLINFO_FAILURE,
    error,
  };
}

function getCreditPullInfoSuccess(pullInfo: $TSFixMe) {
  return {
    type: CREDIT_PULLINFO_SUCCESS,
    pullInfo,
  };
}

export function getCreditPullInfo() {
  const url = utils.getCreditPullDatePath();
  const config: FetchConfig = {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    credentials: 'include',
  };
  return api(url, config, getCreditPullInfoRequest(), getCreditPullInfoSuccess, getCreditPullInfoFailure);
}

function getFulfillmentRequest(topTabId: string) {
  const reportType = topTabId === 'EFX' ? '1B' : '3B';
  return {
    type: CREDIT_FULFILLMENT_REQUEST,
    reportType,
  };
}
function getFulfillmentSuccess(fulfillmentInfo: $TSFixMe) {
  return {
    type: CREDIT_FULFILLMENT_SUCCESS,
    fulfillmentInfo,
  };
}
function getFulfillmentFailure(error: $TSFixMe) {
  return {
    type: CREDIT_FULFILLMENT_FAILURE,
    error,
  };
}

export function getCreditFulfillment(
  bureau: string,
  features: $TSFixMe,
  topTabId: string,
  method: HttpMethod = 'POST'
) {
  const url = utils.getCreditReportPath(bureau);

  const config: FetchConfig = {
    method,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-CSRF-Token': utils.getCookieValue(document.cookie, 'XSRF-TOKEN'),
    },
    credentials: 'include',
    body: JSON.stringify({
      features,
    }),
  };

  return api(url, config, getFulfillmentRequest(topTabId), getFulfillmentSuccess, getFulfillmentFailure);
}

export function clearFulfillmentInfo() {
  return {
    type: CLEAR_FULFILLMENT_INFO,
  };
}

//TransUnion
function getReportHistoryRequest() {
  return {
    type: TU_REPORT_HISTORY_REQUEST,
  };
}

function getReportHistorySuccess(reportHistory: $TSFixMe, localizedStringBundle: StringMap, langCode: $TSFixMe) {
  return {
    type: TU_REPORT_HISTORY_SUCCESS,
    reportHistoryScoreTrend: reportHistory.scoreHistory,
    reportHistory: reportHistory.history,
    newReportAllowed: reportHistory.newReportAllowed,
    nextAvailablePullDate: reportHistory.nextAvailablePullDate,
    nextAvailablePullDateAfterToday: reportHistory.nextAvailablePullDateAfterToday,
    previousScore: reportHistory.previousScore,
    previousScoreDate: reportHistory.previousScoreDate,
    localizedStringBundle,
    langCode,
  };
}

function getReportHistoryFailure(error: $TSFixMe) {
  return {
    type: TU_REPORT_HISTORY_FAILURE,
    error,
  };
}

export function getTuCreditReportHistory(bureau: string, localizedStringBundle: StringMap, langCode: string) {
  const url = utils.getCreditReportHistoryPath(bureau);
  const config: FetchConfig = {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    credentials: 'include',
  };

  return api(
    url,
    config,
    getReportHistoryRequest(),
    (reportHistory: $TSFixMe) => getReportHistorySuccess(reportHistory, localizedStringBundle, langCode),
    getReportHistoryFailure
  );
}

function getReportRequest() {
  return {
    type: TU_REPORT_REQUEST,
  };
}

function getReportSuccess(report: $TSFixMe, localizedStringBundle: StringMap, langCode: $TSFixMe) {
  return {
    type: TU_REPORT_SUCCESS,
    report,
    localizedStringBundle,
    langCode,
  };
}

function getReportFailure(error: $TSFixMe) {
  const errorCode = _get(error, 'code', '');
  return {
    type: TU_REPORT_FAILURE,
    errorCode,
  };
}

export function getTuCreditReport(
  bureau: string,
  localizedStringBundle: StringMap,
  langCode: string,
  method: HttpMethod = 'GET'
) {
  const url = utils.getCreditReportPath(bureau);

  const config: FetchConfig = {
    method,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-CSRF-Token': utils.getCookieValue(document.cookie, 'XSRF-TOKEN'),
    },
    credentials: 'include',
  };

  return api(
    url,
    config,
    getReportRequest(),
    (report: $TSFixMe) => getReportSuccess(report, localizedStringBundle, langCode),
    getReportFailure
  );
}

/**
 * Helper function to build up EFX error logging info
 *
 * @param error
 * @param startTime
 * @returns {Object}
 */
function buildEfxLogInfo(error: $TSFixMe, startTime: $TSFixMe) {
  const elapsedTime = Date.now() - startTime;
  const errorMessage = utils.tryParseJson(_get(error, 'responseText'));
  const statusCode = _get(error, 'status', '');
  const efxEndpoint = _get(error, 'responseURL', '');
  return {
    feature: 'Credit',
    actionType: `EFX client call - ${efxEndpoint}`,
    message: errorMessage ? errorMessage.error : '',
    statusCode,
    elapsedTime,
    clientId: window.isDwm ? 'dwm' : 'dsp',
  };
}
